import React from "react";
import localData from "../../../localData";

export default function About() {
    const { about } = localData.images;

    return (
        <section className="about" id='about' data-lazy-block>
            <div className="container">
                <div className="wrapper">
                    <div className="circle"></div>
                    <div className="circle"></div>
                    <div className="divider"></div>
                </div>
                <div className="about-center">
                    <div className="col col-1">
                        <h2 className="about-title" data-lazy='fade'>about me</h2>
                        <p className="about-description">
                            my name is Karen. I'm a front-end web developer.
                            <br /> 
                            <br /> 
                            I am an innovative, highly motivated organized, and detail-oriented person. I've been
                            working as a web developer for more than 3 years. During these years, I got relevant skills
                            and deep knowledge of the different web technologies:
                        </p>
                    </div>
                    <div className="col col-2" data-tag="img" >
                        <div className="about-image" >
                            <img src={about} alt="about me image" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
